export function isUrl (string = '') {
  const URL_REGEX = new RegExp('^(https?:\/\/)|www+([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$', 'i');
  return string.match(URL_REGEX) !== null;
}
